<template>
  <div class="editor">
    <div class="workbench-body-navbar">
      <div class="workbench-body-navbar-item" @click="undo">
        <Icon type="ios-undo" />
        <span class="navbar-item-name">{{
          $t("message.workBench.body.script.editor.navBar.undo")
        }}</span>
      </div>
      <div class="workbench-body-navbar-item" @click="redo">
        <Icon type="ios-redo" />
        <span class="navbar-item-name">{{
          $t("message.workBench.body.script.editor.navBar.redo")
        }}</span>
      </div>
      <div class="workbench-body-navbar-group">
        <div
          v-show="!script.running"
          v-if="script.executable"
          class="workbench-body-navbar-item"
          title="F3"
          :class="{ disabled: loading }"
          @click.stop="fillUserVariable"
        >
          <Icon type="ios-play" />
          <span class="navbar-item-name">{{
            $t("message.workBench.body.script.editor.navBar.play")
          }}</span>
        </div>
        <div
          v-show="script.running"
          v-if="script.executable"
          class="workbench-body-navbar-item"
          @click.stop="stop"
        >
          <Icon type="md-square" style="color: red" />
          <span class="navbar-item-name">{{
            $t("message.workBench.body.script.editor.navBar.stop")
          }}</span>
        </div>
        <div
          v-if="!script.readOnly"
          class="workbench-body-navbar-item"
          title="Ctrl+S"
          @click="save"
        >
          <Icon type="md-checkmark" />
          <span class="navbar-item-name">{{
            $t("message.workBench.body.script.editor.navBar.save")
          }}</span>
        </div>
        <div
          v-if="!script.readOnly && isSupport"
          class="workbench-body-navbar-item"
          @click="config"
        >
          <Icon type="ios-build" />
          <span class="navbar-item-name">{{
            $t("message.workBench.body.script.editor.navBar.config")
          }}</span>
        </div>
      </div>
      <div class="workbench-body-navbar-item justifyEnd">
        <Select
          v-model="dataSourceId"
          style="width: 350px"
          filterable
          clearable
          placeholder="请选择要查询的数据源~"
          size="small"
          @on-select="setHot"
        >
          <Option
            v-for="item in dataSourceList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="editor-content">
      <we-editor
        ref="editor"
        v-model="script.data"
        :language="script.lang"
        :id="script.id"
        :read-only="script.readOnly"
        :script-type="scriptType"
        :application="script.application"
        type="code"
        @on-operator="heartBeat"
        @on-run="run"
        @on-save="save"
        @is-parse-success="changeParseSuccess"
      />
      <custom-param
        ref="customSetting"
        v-show="showParam"
        :paramList="paramList"
        @custom-setting-close="customSettingClose"
        @custom-setting-save="customSettingSave"
      />
      <setting
        ref="setting"
        v-show="showConfig"
        :script="script"
        :work="work"
        @setting-close="settingClose"
      />
    </div>
  </div>
</template>
<script>
import customParam from "./customParam.vue";
import setting from "./setting.vue";
import api from "@dss/js/service/api";
import storage from "@dss/js/helper/storage";
import { throttle } from "lodash";
import axios from "axios";

import { buildInVariableProposals } from "@dss/js/component/editor/keyword/hql";

export default {
  components: {
    setting,
    customParam,
  },
  props: {
    script: {
      type: Object,
      required: true,
    },
    work: {
      type: Object,
      required: true,
    },
    scriptType: {
      type: String,
      default: "workspaceScript",
    },
  },
  data() {
    return {
      showConfig: false,
      loading: false,
      isParseSuccess: true,
      dataSourceId: this.work.sourceId ? this.work.sourceId : "",
      dataSourceList: [],
      showParam: false,
      paramList: [],
    };
  },
  computed: {
    listenResource() {
      return this.script.running;
    },
    isHdfs() {
      return this.work.filepath.indexOf("hdfs") === 0;
    },
    isSupport() {
      return this.script.executable;
    },
  },
  watch: {
    listenResource(val) {
      if (!val) {
        api
          .fetch(
            "/jobhistory/list",
            {
              pageSize: 100,
              status: "Running,Inited,Scheduled",
            },
            "get"
          )
          .then((rst) => {
            this.dispatch("Footer:updateRunningJob", rst.tasks.length);
          })
          .catch((err) => {});
      }
    },
    "work.unsave"(val) {
      if (!val) {
        this.$refs.setting.origin = JSON.stringify(this.script.params);
      }
    },
    dataSourceId(val) {
      if (val !== this.work.sourceId) {
        this.work.sourceId != null && (this.work.unsave = true);
        this.$emit("changeSourceId", val);
      }
    },
  },
  mounted() {
    this.getDataSourceList();
  },
  methods: {
    getDataSourceList() {
      let dataSourceType = "hive,mysql,rds,gp,es,clickhouse,doris";
      axios
        .get(`/api/rest_j/v1/metadata/v1/getAllDBSource?type=${dataSourceType}`)
        .then((res) => {
          if (!res.data || !Array.isArray(res.data) || res.data.length <= 0) {
            this.$Message.warning("没有数据源可供选择，无法进行探查~");
          }
          /*  if(this.work.type == 'hdfsScript'){
            res.data = res.data.filter(item => item.type == 'hive')
          } */
          this.dataSourceList = res.data.map((item) => ({
            id: `${item.type}@${item.sourceId}`,
            name: item.sourceName,
          }));
          if (!this.dataSourceId) {
            this.dataSourceId = this.dataSourceList[0].id;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    "Workbench:insertValue"(args) {
      if (args.id === this.script.id) {
        this.$refs.editor.insertValueIntoEditor(args.value);
      }
    },
    "Workbench:setParseAction"(id) {
      if (id === this.script.id) {
        const editor = this.$refs.editor;
        if (editor) {
          const isParserClose = !!storage.get("isParserClose", "local");
          editor.isParserClose = isParserClose;
          editor.closeParser && editor.closeParser.set(!isParserClose);
          editor.openParser && editor.openParser.set(isParserClose);
        }
      }
    },
    undo() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 127, type: "click" }]);
      }
      this.$refs.editor.undo();
    },
    redo() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 128, type: "click" }]);
      }
      this.$refs.editor.redo();
    },
    // 点运行按钮先对自定义变量进行处理
    fillUserVariable() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 129, type: "click" }]);
      }
      // if (!this.isParseSuccess) return this.$Message.warning('代码中有语法错误，请检查后再试！');
      if (this.script.running)
        return this.$Message.warning(
          this.$t("message.workBench.body.script.editor.warning.running")
        );
      let selectCode = this.$refs.editor.getValueInRange() || this.script.data;
      // console.log(selectCode);
      if (!selectCode) {
        this.$Message.warning(this.$t("脚本内容不能为空"));
        return;
      }

      // 从editor脚本中取自定义变量,自定义变量以$${aa}形式
      if (selectCode.indexOf("$${") > -1) {
        let param = selectCode.match(/\$\$\{(.+?)\}/g);
        // 去重
        param = Array.from(new Set(param));

        // 取内嵌的系统变量，筛出自定义变量
        // let sysVariable = buildInVariableProposals.map((item,index)=> item.label);

        // let selfParam = param.filter((varStr,inx)=> sysVariable.indexOf(varStr.replace(/\$\$\{/,'').replace(/\}/,''))<0)

        // 若有自定义变量，弹出自定义变量窗口 showParam=true
        if (param.length > 0) {
          this.showParam = true;

          // 自定义变量窗口中，取localstorage中的存的key,value填充,，
          let userDefinedVar = JSON.parse(
            window.localStorage.getItem("userDefinedVar")
          );

          let paramListTmp = [];
          param.filter((item, ind) => {
            let itemStr = item.replace(/\$\$\{/, "").replace(/\}/, "");

            let keyArray = userDefinedVar && Object.keys(userDefinedVar);

            if (keyArray && keyArray.indexOf(itemStr) > -1) {
              paramListTmp.push({
                key: itemStr,
                value: userDefinedVar[itemStr],
              });
            } else {
              paramListTmp.push({ key: itemStr, value: "" });
            }
          });
          this.paramList = paramListTmp;
        } else {
          // 无自定义变量
          this.run();
        }
      } else {
        // 无变量
        this.run();
      }
    },
    async run() {
      let selectCode = this.$refs.editor.getValueInRange() || this.script.data;

      let validRepeat = await this.validateRepeat();
      this.$refs.editor.deltaDecorations(selectCode, (flag) => {
        // if (!flag) {
        //     return this.$Message.warning('代码中有语法错误，请检查后再试！');
        // }
        if (!validRepeat)
          return this.$Message.warning(
            this.$t("message.workBench.body.script.editor.warning.invalidArgs")
          );
        if (this.loading)
          return this.$Message.warning(
            this.$t("message.constants.warning.api")
          );
        if (!selectCode) {
          return this.$Message.warning(
            this.$t("message.workBench.body.script.editor.warning.emptyCode")
          );
        }
        this.loading = true;
        this.$emit(
          "on-run",
          {
            code: selectCode,
            id: this.script.id,
            dataSourceId: this.dataSourceId,
          },
          (status) => {
            // status是start表示已经开始执行
            let list = ["execute", "error", "start", "downgrade"];
            if (list.indexOf(status) > -1) {
              this.loading = false;
            }
          }
        );
      });
    },
    stop() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 130, type: "click" }]);
      }
      if (this.loading)
        return this.$Message.warning(this.$t("message.constants.warning.api"));
      this.loading = true;
      this.$emit("on-stop", (isKilled) => {
        this.loading = false;
      });
    },
    async save() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 131, type: "click" }]);
      }
      let valid = await this.validateRepeat();
      if (!valid)
        return this.$Message.warning(
          this.$t("message.workBench.body.script.editor.warning.invalidArgs")
        );
      this.$refs.editor.save();
      this.$emit("on-save");
    },
    config() {
      if (localStorage.getItem("isScriptManage")) {
        this.sendTrack([{ pageId: 20, buttonId: 132, type: "click" }]);
      }
      this.showConfig = !this.showConfig;
    },
    settingClose() {
      this.showConfig = false;
    },
    async runWithParams() {
      let selectCode = this.$refs.editor.getValueInRange() || this.script.data;

      this.$refs.editor.deltaDecorations(selectCode, (flag) => {
        if (this.loading)
          return this.$Message.warning(
            this.$t("message.constants.warning.api")
          );

        this.loading = true;
        this.$emit(
          "on-run",
          {
            code: selectCode,
            id: this.script.id,
            variable: this.paramList,
            dataSourceId: this.dataSourceId,
          },
          (status) => {
            // status是start表示已经开始执行
            let list = ["execute", "error", "start", "downgrade"];
            if (list.indexOf(status) > -1) {
              this.loading = false;
            }
          }
        );
      });
    },
    customSettingClose() {
      this.showParam = false;
      this.$refs.customSetting.$refs.customForm.$refs.commonForm.resetFields();
    },
    async customSettingSave() {
      this.showParam = !this.showParam;

      let paramListTmp = this.paramList;

      // 校验窗口中参数的值是否有空
      // let valid = true;
      // 表单验证返回是个promise，所以需要用await
      // let valid = await this.validateRepeat();
      let valid = true;
      valid =
        await this.$refs.customSetting.$refs.customForm.$refs.commonForm.validate(
          (valid) => {
            // 如果验证没通过，要打开setting页面
            if (!valid) {
              this.showParam = true;
            }
            return valid;
          }
        );

      if (!valid)
        return this.$Message.warning(
          this.$t("message.workBench.body.script.editor.warning.invalidArgs")
        );

      let keyList = paramListTmp.map((item, index) => item.key);

      // 关闭的时候，将窗口的值添加到缓存
      let userDefinedVar = JSON.parse(
        window.localStorage.getItem("userDefinedVar")
      );

      keyList.forEach((key, index) => {
        if (!userDefinedVar) {
          userDefinedVar = new Object();
        }

        userDefinedVar[key] = paramListTmp[index].value;
      });

      window.localStorage.setItem(
        "userDefinedVar",
        JSON.stringify(userDefinedVar)
      );

      this.runWithParams();
    },
    heartBeat: throttle(() => {
      api.fetch("/user/heartbeat", "get");
    }, 60000),
    // 对this.script.params.variable里面是否存在key重复性进行校验
    // 这里要注意，html结构不能用v-if，只能用v-show，让设置模块处于要渲染状态
    // 否则会需要使用nextTick中await，会发生打开后没渲染的情况。
    async validateRepeat() {
      const setting = this.$refs.setting;
      let valid = true;
      // 当没有自定义参数的时候不做判断
      if (this.script.params.variable.length) {
        // 表单验证返回是个promise，所以需要用await
        valid =
          await setting.$refs.customVariable.$refs.form.$refs.dynamicForm.validate(
            (valid) => {
              // 如果验证没通过，要打开setting页面
              if (!valid) {
                this.showConfig = true;
              }
              return valid;
            }
          );
      }
      if (
        setting.$refs.envVariable &&
        this.script.params.configuration.runtime.env.length
      ) {
        valid =
          await setting.$refs.envVariable.$refs.form.$refs.dynamicForm.validate(
            (valid) => {
              // 如果验证没通过，要打开setting页面
              if (!valid) {
                this.showConfig = true;
              }
              return valid;
            }
          );
      }
      return valid;
    },
    changeParseSuccess(flag) {
      this.isParseSuccess = flag;
    },
    setHot(sourceId) {
      let countMap = storage.get("unicorneye-HotDataSource", "local");
      if (!countMap) {
        countMap = {};
      }
      let count = countMap[sourceId] || 0;
      countMap[sourceId] = count++;
      storage.set("unicorneye-HotDataSource", countMap, "local");
    },
  },
};
</script>
